import React, { useState } from 'react';
import './Login.css';

const Login = ({ onLoginSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const response = await fetch('/api/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();

      if (response.ok) {
        onLoginSuccess(data.user); // Pass the user object
      } else {
        // Əgər serverdən detallı xəta (detail) gəlibsə, onu da mötərizədə göstəririk
        const errorMsg = data.detail 
          ? `${data.message} (${data.detail})` 
          : (data.message || 'Giriş uğursuz oldu.');
        setError(errorMsg);
      }
    } catch (err) {
      console.error('Login error:', err);
      setError('Serverlə əlaqə qurulmadı.');
    }
  };

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleLogin}>
        <h2>Mütəxəssis Girişi</h2>
        <div className="input-group">
          <input
            type="text"
            placeholder="İstifadəçi Adı"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div className="input-group">
          <input
            type="password"
            placeholder="Şifrə"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="login-button">Daxil Ol</button>
        {error && <p className="error-message">{error}</p>}
      </form>
    </div>
  );
};

export default Login;
